import { postRequest, getRequest } from ".";

export const applyCouponCode = (payload) => {
  return postRequest("/stripe/apply-coupon", payload);
};

export const getPublicPlans = () => {
  return getRequest("/stripe/stripe-plans");
};
